import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import socket from './modules/socket'
import apps from './modules/apps'
import background from './modules/background'
import notification from './modules/notification'
import delegation from './modules/delegation'
import corporateGovernance from './modules/corporateGovernance'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    user,
    socket,
    notification,
    apps,
    background,
    delegation,
    corporateGovernance
  }
})
